import styled from 'styled-components';

export const Wrapper = styled.div`
  .PhoneInputCountryIcon {
    margin-left: 8px;
  }

  .PhoneInputCountry:has(.PhoneInputCountrySelect:focus-visible) {
    outline: 2px solid #1d88ff;
    outline-offset: 2px;
    border-radius: 2px;
  }

  &&& input {
    padding-right: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: auto;
    border: 0;
  }
`;
